import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';
import type { ColumnAlignmentType, ColumnDataType } from './types';

const ALIGNMENT_CLASS_MAP: Record<ColumnAlignmentType, string> = {
  left: alignStyles.alignLeft,
  center: alignStyles.alignCenter,
  right: alignStyles.alignRight,
};

const DATA_TYPE_ALIGNMENT_MAP: Record<ColumnDataType, string> = {
  money: alignStyles.alignRight,
  percent: alignStyles.alignRight,
  number: alignStyles.alignRight,
  date: alignStyles.alignRight,
  abbreviation: alignStyles.alignCenter,
  badge: alignStyles.alignCenter,
  status: alignStyles.alignCenter,
  checkbox: alignStyles.alignCenter,
  icon: alignStyles.alignCenter,
  text: alignStyles.alignLeft,
  list: alignStyles.alignLeft,
};

export const resolveAlignment = (
  dataType: ColumnDataType,
  options: {
    isFirstDataColumn?: boolean,
    isLastColumn?: boolean,
    customAlign?: ColumnAlignmentType,
  } = {},
): string => {
  const { isFirstDataColumn, isLastColumn, customAlign } = options;

  if (isFirstDataColumn) {
    return alignStyles.alignLeft;
  }

  if (isLastColumn) {
    return alignStyles.alignRight;
  }

  if (customAlign) {
    return ALIGNMENT_CLASS_MAP[customAlign];
  }

  return DATA_TYPE_ALIGNMENT_MAP[dataType] ?? alignStyles.alignLeft;
};
